import classNames from "classnames";
import React, { FC, ReactNode } from "react";
import { Button, ButtonSize } from '../Partials/Button';
import { StreamLineIcons, StreamLineIcon } from "../../SvgIcon/StreamLineIcon";

interface FormControlsProps {
  onSubmit?: () => void;
  discardButtonLabel?: string | ReactNode;
  discardButtonIcon?: StreamLineIcons;
  submitButtonLabel?: string | ReactNode;
  buttonsSize?: ButtonSize;
  submitButtonIcon?: StreamLineIcons;
}

export const FormControls: FC<FormControlsProps> = (props) => {
  const {
    onSubmit,
    discardButtonLabel,
    discardButtonIcon,
    submitButtonLabel,
    submitButtonIcon,
    buttonsSize = 'large'
  } = props;

  return (
    <div
      className={classNames("insuranceFormControls", {
        "insuranceFormControls--bothIcons":
          discardButtonIcon && submitButtonIcon,
      })}
    >
      <Button
        className="insuranceFormControls__button insuranceFormControls__button--discard"
        type="solid"
        size={buttonsSize}
        tier="secondary"
        htmlType="reset"
      >
        <span className="insuranceButton__label">
          {discardButtonIcon && (
            <StreamLineIcon
              iconName={discardButtonIcon}
              className="insuranceFormControls__icon"
            />
          )}
          <span className="insuranceFormControls__label">
            {discardButtonLabel ?? "Discard"}
          </span>
        </span>
      </Button>
      <Button
        className="insuranceFormControls__button insuranceFormControls__button--submit"
        type="solid"
        size={buttonsSize}
        tier="tertiary"
        htmlType="submit"
        onClick={onSubmit}
      >
        <span className="insuranceButton__label">
          {submitButtonIcon && (
            <StreamLineIcon
              iconName={submitButtonIcon}
              className="insuranceFormControls__icon"
            />
          )}
          <span className="insuranceFormControls__label">
            {submitButtonLabel ?? "Request a booking"}
          </span>
        </span>
      </Button>
    </div>
  );
};
